<template>
  <div
    class="login"
    :class="{ 'login-zhiyun-version': versionConfig.ZHIYUN_VERSION }"
  >
    <div class="nav">
      <div class="nav-inner">
        <img
          class="hy-logo"
          :src="
            versionConfig.ZHIYUN_VERSION
              ? `/images/${
                  appConfig.logo_sm ? appConfig.logo_sm : 'zy_logo_sm.png'
                }`
              : '/images/logo.png'
          "
        />
        <span class="desc" v-if="versionConfig.ZHIYUN_VERSION">
          <span v-if="appConfig.slogan">{{ appConfig.slogan }}</span>
          <span v-else>智慧领航&nbsp; 云享未来</span>
        </span>
        <span class="desc" v-else>高效运营&nbsp; 宾客如云</span>
        <span class="wx-info hy-info">
          关注鸿云公众号
          <a-popover title="扫码关注鸿云公众号" placement="leftTop">
            <template slot="content">
              <img src="/images/hy_wx.jpg" style="width:200px" alt="" />
            </template>
            <span>
              <img src="/images/hy_wx.jpg" class="wx-img" alt="" />
            </span>
          </a-popover>
        </span>
      </div>
    </div>
    <div class="logo"></div>
    <div class="login-bg">
      <div class="login-form-box">
        <h1>Welcome!</h1>
        <h2 style="position:relative">
          欢迎使用
        </h2>
        <a-form :form="form" class="login-form" @submit="handleSubmit">
          <span class="qrCode" @click="changeLogMode">
            <img
              src="@/assets/images/qrCode.png"
              alt="二维码"
              v-if="!isQrCode"
            />
            <img src="@/assets/images/pc_icon.png" alt="电脑" v-else />
          </span>
          <a-spin :spinning="spinning" v-if="isQrCode">
            <div class="qr-box">
              <span v-if="isExpire" @click="reflesh" class="layer">
                <a-icon type="reload" />
                二维码失效 点击重试
              </span>
              <img :src="imgurl" alt="扫码登录" />
              <small>请使用微信扫码登录</small>
            </div>
          </a-spin>
          <div v-else>
            <a-form-item>
              <a-input
                v-decorator="[
                  'CompanyCode',
                  { rules: [{ required: true, message: '请输入门店编号!' }] }
                ]"
                placeholder="门店编号"
                size="large"
              >
                <a-icon slot="prefix" type="team" class="prefix-icon" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="[
                  'Account',
                  { rules: [{ required: true, message: '请输入用户名!' }] }
                ]"
                placeholder="用户名"
                size="large"
              >
                <a-icon slot="prefix" type="user" class="prefix-icon" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="['Password']"
                type="password"
                size="large"
                placeholder="登录密码"
              >
                <a-icon slot="prefix" type="lock" class="prefix-icon" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-checkbox
                v-decorator="[
                  'remember',
                  {
                    valuePropName: 'checked',
                    initialValue: false
                  }
                ]"
              >
                记住密码
              </a-checkbox>
              <!-- <a class="login-form-forgot" href="">
            忘记密码？
          </a> -->
              <a-button
                type="primary"
                html-type="submit"
                class="login-form-button"
                size="large"
                :loading="loading"
              >
                登录
              </a-button>
              <!-- <a-button @click="getQrCode">
            扫码登录
          </a-button> -->
            </a-form-item>
          </div>
        </a-form>
      </div>
      <div class="login-baner">
        <div class="login-baner-bg">
          <div class="main">
            <div class="image-box">
              <div class="pc"></div>
              <div class="mobile"></div>
            </div>
            <div class="box">
              <div class="img2"></div>
            </div>
          </div>
          <div class="sub"></div>
          <div class="img1"></div>
        </div>
      </div>
    </div>
    <div>
      <a-modal
        title="选择班次"
        :visible="visible"
        @ok="handleOk"
        :confirmLoading="confirmLoading"
        @cancel="handleCancel"
        width="400px"
        :centered="modalCenter"
      >
        <div style="text-align:center">
          <a-select
            style="width: 300px;"
            @change="handleChange"
            :defaultValue="firstSelect"
          >
            <a-select-option
              v-for="(item, index) in classArray"
              :key="index"
              :value="item.Id"
              >{{ item.Name + " " + item.TimeRange }}</a-select-option
            >
          </a-select>
        </div>
      </a-modal>
    </div>
    <!-- <a-modal
      title="扫码登录"
      :visible="visibleCode"
      @cancel="visibleCode = false"
      width="350px"
      :centered="true"
      :footer="null"
    >
      <a-spin :spinning="spinning">
        <div class="qr-box">
          <span>可点击二维码刷新</span>
          <img :src="imgurl" alt="扫码登录" @click="getQrCode" />
          <small>请使用微信扫码登录</small>
        </div>
      </a-spin>
    </a-modal> -->
    <div class="footer">
      {{ appConfig.copyRight ? appConfig.copyRight : "Copyright ©2019" }}
      {{
        versionConfig.ZHIYUN_VERSION
          ? appConfig.title
            ? appConfig.title
            : "智云Plus"
          : "鸿云"
      }}住宿管理系统
      <span style="margin-left:10px">版本号：{{ version }}</span>
    </div>
    <span class="zy-info">
      <a-popover placement="leftTop">
        <template slot="title">
          <div style="display:flex;justify-content: space-between;">
            <span>客服联系电话</span>
            <span class="qq" @click.stop="onClickQQ"
              ><a-icon type="qq" />QQ</span
            >
          </div>
        </template>
        <template slot="content">
          <div v-if="appConfig.tel && appConfig.tel.length">
            <div
              style=" font-size: 26px;color: #ec0000;font-family: fantasy;"
              v-for="(item, index) in appConfig.tel"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div v-else>
            <span style=" font-size: 26px;color: #ec0000;font-family: fantasy;"
              >400 - 0773 - 021</span
            ><br />
            <!-- <span style=" font-size: 26px;color: #ec0000;font-family: fantasy;"
              >400 - 1189 - 669</span
            > -->
          </div>
        </template>
        <h3><a-icon type="phone" /> 联系客服</h3>
      </a-popover>
      <div class="code-img" v-if="!appConfig.isHiddenWX">
        <p>关注微信公众号</p>
        <img
          :src="
            `/images/${appConfig.wxImage ? appConfig.wxImage : 'zy_wx.jpg'}`
          "
          class="wx-img"
          alt=""
        />
      </div>
    </span>
  </div>
</template>

<script>
import "./login.less";
import md5 from "js-md5";
import { cache } from "@/utils/common";
import { mapActions, mapState } from "vuex";
import authLoginModal from "./authLogin";
export default {
  data() {
    return {
      versionConfig,
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      confirmLoading: false,
      classArray: [],
      setClass: {},
      firstSelect: "",
      modalCenter: true,
      defaultPage: "",
      version: "",
      remember: {},
      defaultMenuArr: [
        //集团默认页面码
        { Code: "G_HomePage", RouterName: "groupIndex" },
        { Code: "G_OrderCenter", RouterName: "centralOrder" },
        { Code: "G_Order", RouterName: "groupOrderManage" },
        { Code: "G_Company", RouterName: "shopManage" },
        { Code: "G_Member", RouterName: "member" },
        { Code: "G_GroupCustomer", RouterName: "groupClientManage" },
        { Code: "G_GroupReport", RouterName: "GroupReportCenter" },
        { Code: "G_Maintenance", RouterName: "maintenance" },
        { Code: "G_User", RouterName: "groupUserManage" },
        //单店默认页面码
        { Code: "HomePage", RouterName: "dashboard" },
        { Code: "GuestRoom", RouterName: "roommanage" },
        { Code: "Order", RouterName: "orderManage" },
        { Code: "Marketing", RouterName: "salesmanage" },
        { Code: "Channel", RouterName: "channelManage" },
        { Code: "NightAudit", RouterName: "nightCheckManage" },
        { Code: "Member", RouterName: "member" },
        { Code: "AccountsReceivable", RouterName: "Armanage" },
        { Code: "Report", RouterName: "reportCenter" },
        { Code: "Maintenance", RouterName: "maintenance" },
        { Code: "User", RouterName: "userManage" },
        { Code: "Restaurant", RouterName: "restaurant" },
        { Code: "Warehouse", RouterName: "warehouse" },
        { Code: "Breakfast", RouterName: "meal" },
        { Code: "GuestHistory", RouterName: "guestHistory" }
      ],
      imgurl: "",
      // visibleCode: false,
      spinning: false,
      isQrCode: false,
      isExpire: false
    };
  },
  computed: {
    ...mapState({
      appConfig: state => state.app.appConfig
    })
  },
  mounted() {
    // this.form.setFieldsValue({
    //   CompanyCode: "test",
    //   Account: "superadmin"
    // });
    this.setUserMenu(false);
    this.remember = cache.get("user_remember");
    if (this.remember != null) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          CompanyCode: this.remember.CompanyCode,
          Account: this.remember.Account,
          Password: this.remember.Password.split("-")[1],
          remember: this.remember.remember
        });
      });
    }
    this.$post("Common_GetVersionNo").then(res => {
      this.version = res.Data;
    });
  },
  methods: {
    ...mapActions(["setMenus", "setUserMenu"]),
    changeLogMode() {
      this.isQrCode = !this.isQrCode;
      if (this.isQrCode) {
        if (!this.imgurl) {
          this.getQrCode();
        }
      }
    },
    reflesh() {
      this.isExpire = false;
      this.getQrCode();
    },
    getQrCode() {
      const _this = this;
      // this.visibleCode = true;
      cache.remove("LogInfo");
      if (!this.isExpire) {
        this.spinning = true;
        this.$post("WxAuth_GetQRCoder", {
          IsZYPlus: versionConfig.ZHIYUN_VERSION
        }).then(response => {
          this.imgurl = "data:image/jpeg;base64," + response.Data.QRCode;
          this.spinning = false;
          this.$post(
            "WxAuth_GetToken",
            { Id: response.Data.KeyId, IsZYPlus: versionConfig.ZHIYUN_VERSION },
            { timeout: 3 * 60000 }
          )
            .then(res => {
              const json = {
                Account: res.Data.Account,
                CompanyCode: res.Data.CompanyCode
              };
              cache.set("LogInfo", json);
              this.setUserMenu(true);
              _this.classArray = res.Data.Shifts;
              var homePage = this.getDefaultMenu(res.Data);
              if (res.Data.Shifts == "") {
                cache.set("user", res.Data, 480 * 60 * 1000);
                //跳转路由
                this.showRegisterMsg();
                _this.$router.push({
                  name: homePage
                });
              } else {
                if (res.Data.Shifts.length == 1) {
                  _this.setClass = res.Data.Shifts[0];
                  cache.set("user", res.Data, 480 * 60 * 1000);
                  _this.$post("SetShift", _this.setClass).then(() => {
                    this.showRegisterMsg();
                    _this.$router.push({
                      name: homePage
                    });
                  });
                } else {
                  _this.firstSelect = res.Data.Shifts[0].Id;
                  _this.setClass = res.Data.Shifts[0];
                  _this.visible = true;
                  cache.set("user", res.Data, 480 * 60 * 1000);
                }
              }
            })
            .catch(() => {
              this.isExpire = true;
              this.spinning = false;
            });
        });
      }
    },
    // polling(url, param, delay = 10000) {
    //   return new Promise((resolve, reject) => {
    //     this.$post(url, param).then(res => {
    //       if (res.Data.Token) {
    //         setTimeout(() => {
    //           resolve(this.polling(url, param, delay));
    //         }, delay);
    //       } else {
    //         resolve(res);
    //       }
    //     });
    //   });
    // },
    handleSubmit(e) {
      e.preventDefault();
      this.setMenus([]);
      cache.remove("LogInfo");
      cache.remove("isFirstIn");
      cache.remove("isNoRemindAuditRemind");
      const that = this;
      that.form.validateFields((err, values) => {
        if (!err) {
          const json = {
            Account: values.Account,
            CompanyCode: values.CompanyCode
          };
          if (values.Password) {
            json.Password = md5(values.Password);
          }
          that.loading = true;
          that
            .$post("GetToken", json)
            .then(res => {
              if (
                values.Account.toLowerCase() == "superadmin" &&
                process.env.VUE_APP_ENV !== "development"
              ) {
                authLoginModal({
                  token: res.Data.Token,
                  companyCode: values.CompanyCode,
                  submit: () => {
                    that.onSubmitAfter(json, values, res);
                  },
                  cancel: () => {
                    that.loading = false;
                  }
                });
              } else {
                that.onSubmitAfter(json, values, res);
              }
              // that.onSubmitAfter(json, values, res);
            })
            .catch(() => {
              that.loading = false;
              // that.$message.info(e.data.Message);
              return;
            });
        }
      });
    },
    onSubmitAfter(json, values, res) {
      let that = this;
      cache.set("LogInfo", json);
      this.isRemmberPass(json, values.Password);
      that.classArray = res.Data.Shifts;
      var homePage = this.getDefaultMenu(res.Data);
      this.setUserMenu(true);
      if (res.Data.Shifts == "") {
        cache.set("user", res.Data, 480 * 60 * 1000);
        //跳转路由
        this.showRegisterMsg();
        that.loading = false;
        that.$router.push({
          name: homePage
        });
      } else {
        if (res.Data.Shifts.length == 1) {
          that.setClass = res.Data.Shifts[0];
          cache.set("user", res.Data, 480 * 60 * 1000);
          that.$post("SetShift", that.setClass).then(() => {
            this.showRegisterMsg();
            that.$router.push({
              name: homePage
            });
          });
        } else {
          that.firstSelect = res.Data.Shifts[0].Id;
          that.setClass = res.Data.Shifts[0];
          that.visible = true;
          cache.set("user", res.Data, 480 * 60 * 1000);
          this.loading = false;
        }
      }
    },
    showRegisterMsg() {
      setTimeout(() => {
        const user = cache.get("user");
        if (user.RegisterMessage) {
          this.$warning({
            title: "门店到期提醒",
            content: () => <div style="color:red;">{user.RegisterMessage}</div>,
            width: 435
          });
        }
      }, 3000);
    },
    //获取默认角色菜单
    getDefaultMenu(data) {
      if (data.IsGroupSystem) {
        this.defaultPage = "shopManage";
        return this.defaultPage;
      }
      let code = "GuestRoom";
      const defaultMenu = data.Menus.find(p => p.Code == code);
      if (!defaultMenu) {
        code = data.Menus[0].Code;
      }
      const item = this.defaultMenuArr.find(x => x.Code == code);
      this.defaultPage = item ? item.RouterName : "roommanage";
      return this.defaultPage;
      // let defaultMenu = data.Menus.find(p => p.Checked);
      // if (defaultMenu) {
      //   let item = this.defaultMenuArr.find(x => x.Code == defaultMenu.Code);
      //   if (item) {
      //     this.defaultPage = item.RouterName;
      //     return this.defaultPage;
      //   } else {
      //     if (data.IsGroupSystem == true) {
      //       this.defaultPage = "shopManage";
      //     } else {
      //       this.defaultPage = "roommanage"; //"dashboard";
      //     }
      //   }
      // } else {
      //   if (data.IsGroupSystem == true) {
      //     this.defaultPage = "shopManage";
      //   } else {
      //     this.defaultPage = "roommanage"; //"dashboard";
      //   }
      // }
    },
    handleOk() {
      if (this.setClass == "") {
        this.$message.info("请选择班次");
        return;
      }
      this.confirmLoading = true;
      this.$post("SetShift", this.setClass)
        .then(() => {
          this.confirmLoading = false;
          this.showRegisterMsg();
          this.$router.push({
            name: this.defaultPage //"index"
          });
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    isRemmberPass(json, pass) {
      const remember = this.form.getFieldValue("remember");
      json.remember = remember;
      json.Password = json.Password ? json.Password + "-" + pass : "";
      if (remember) {
        cache.set("user_remember", json);
      } else {
        cache.remove("user_remember");
      }
    },
    handleCancel() {
      this.visible = false;
    },
    handleChange(value) {
      for (let i = 0; i < this.classArray.length; i++) {
        if (value == this.classArray[i].Id) {
          this.setClass = this.classArray[i];
        }
      }
    },

    onClickQQ() {
      window.open(
        "https://wpa1.qq.com/6877huiG?_type=wpa&qidian=true",
        "_blank"
      );
    }
  }
};
</script>
<style lang="less" scoped>
.qq {
  cursor: pointer;
  color: #1890ff;
}
</style>
